import tw, { styled } from 'twin.macro';
import ListItem from '../ListItem/ListItem';

export default styled(ListItem)(() => [tw`items-center`]);
